<template>
  <span>
    {{moneyString}}
  </span>
</template>

<script>
import {
  formatMoney,
  getBigAmount,
  CURRENCY_NAMES,
} from '@/utilities/money';

export default {
  name: 'MoneyString',
  props: {
    amount: Number,
    currency: String,
    type: String,
  },
  computed: {
    moneyString() {
      if (this.amount && this.currency) {
        return this.type === 'name' ? this.withName() : formatMoney(this);
      }
      return null;
    },
  },
  methods: {
    withName() {
      const currencyName = CURRENCY_NAMES[this.currency];
      return `${getBigAmount(this.amount)} ${currencyName.toLowerCase()}`;
    },
  },
};
</script>
